/**
 *
 * @author Iecisa
 */
export class EventParamDTO {

    pageOffset: Number;
    pageSize: Number;
    startDate: string;
    endDate: string;
    policyNumber: string;
    statusType: any[];
    product: any[];
    policyItems: any[];
    eventItems: any[];
    isTaker: boolean;

}
